import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { ColorAnchor } from 'seagull/icons';
import styles from './MapAccountsModal.module.scss';
export const columnDefs = [
    {
        width: 400
    },
    {
        width: 400
    },
    {
        width: 260
    }
];
export const makeHeaderItems = (texts)=>[
        {
            value: /*#__PURE__*/ _jsxs("div", {
                className: styles.columnHeader,
                children: [
                    /*#__PURE__*/ _jsx(ColorAnchor, {
                        className: styles.icon
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        children: texts.accountType()
                    })
                ]
            })
        },
        {
            value: /*#__PURE__*/ _jsx("div", {
                className: styles.columnHeader,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    children: texts.accountName()
                })
            })
        },
        {
            value: texts.status()
        }
    ];
